<template>
  <div class="vue-wrapper">
    <header v-if="$route.name !== 'KundeKontraktObjektFullscreen'">
      <MainToolbar/>
      <MainNavigation/>
    </header>

    <main>
      <router-view></router-view>

      <span class="nav-close"></span>
    </main>
  </div>
</template>

<script>
import MainNavigation from '../components/Admin/TheMainNavigation'
import MainToolbar from '../components/Admin/TheMainToolbar'

export default {
  name: 'layout',
  components: {
    MainNavigation,
    MainToolbar
  },
  methods: {
    closeMobileMenu: function () {
      // Open is in TheMainToolbar
      window.jQuery('body').toggleClass('nav-open')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/AdminLayout.vue